export default "__VITE_ASSET__BJmd$fP___"